import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export function handleResponseError(
  error: HttpErrorResponse
): Observable<never> {
  let errorMessage = 'An unknow error ocurred, try again later';
  if (error.error instanceof ErrorEvent) {
    errorMessage = `${error.error.message}`;
  } else {
    errorMessage = `${error.error.message}`;
  }
  return throwError(() => new Error(errorMessage));
}
